import React from "react";
import styled from "styled-components";
import { greyText } from "../../../styles";
import { CompassParagraph } from "../styledComponents";

const DetailRowContainer = styled.div<{ gap?: number }>`
  display: flex;
  align-items: center;
  gap: ${({ gap }): number => gap ?? 1}px;
`;

const Label = styled(CompassParagraph)<{ minWidth?: number }>`
  font-size: 13px;
  color: ${greyText};
  margin: 0;
  min-width: ${({ minWidth }): number => minWidth ?? 100}px;
`;

const Value = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
`;

export interface ModalDetailRowProps {
  /** Label text */
  label: string;
  /** Minimum width for label (default: 100) */
  labelMinWidth?: number;
  /** Gap between label and value (default: 8) */
  gap?: number;
  /** Content/value to display */
  children: React.ReactNode;
}

/**
 * A horizontal row with a label and value, commonly used for displaying key-value pairs
 */
export const ModalDetailRow: React.FC<ModalDetailRowProps> = ({
  label,
  labelMinWidth,
  gap,
  children,
}) => {
  return (
    <DetailRowContainer gap={gap}>
      <Label minWidth={labelMinWidth}>{label}</Label>
      <Value>{children}</Value>
    </DetailRowContainer>
  );
};

/**
 * Styled label component for standalone use
 */
export const ModalLabel = Label;
